import { fechFromBPartsApi } from '../utils';

const addToCart = async ({
  locale,
  product_id,
  csrftoken,
  is_advanced_view = false,
  detail_view = 'false',
}: {
  locale: string;
  product_id: number;
  csrftoken: string;
  is_advanced_view?: boolean;
  detail_view?: string;
}) => {
  const search = new URLSearchParams();

  if (is_advanced_view) {
    search.append('is_advanced_view', 'true');
  }

  if (detail_view) {
    search.append('detailed_prices', detail_view);
  } else {
    search.append('detailed_prices', 'false');
  }

  const data = await fechFromBPartsApi(
    `/${locale}/shop/carts/cart?` + search.toString(),
    {
      method: 'POST',
      credentials: 'include',
      headers: new Headers([
        ['Content-Type', 'application/json'],
        ['X-CSRFToken', csrftoken],
        ['b-origin', process.env.NEXT_PUBLIC_TENANT || '1'],
      ]),
      body: JSON.stringify({ product: product_id }),
    }
  );

  return data.json();
};

export default addToCart;
